module.exports = __webpack_public_path__ + "static/media/horizon.c5cee2c6.png";